/* eslint-disable camelcase */
import axios from 'axios';

/**
 * Format Line データ取得APIのURL
 * いまはjsonファイルだけど将来的にDB管理したい
 */
const apiUrl = '/FL.json';

/**
 * デザインサンプル(S3)のドメイン
 */
export const designBaseUrl = 'https://contents.rals.biz';

export const iconEnJa = {
  popular: '人気',
  recommend: 'オススメ',
  cms: 'CMS',
  cms_detail: 'CMS',
  trial: 'デモ画面あり',
} as const;

export type IconType = keyof typeof iconEnJa;

export type Design = {
  type: string;
  ja_name: string;
  en_name: string;
  colors: string[];
  demo_color_id: string;
  is_new: boolean;
};

export type Content = {
  price?: number;
  en_name: string;
  ja_name: string;
  description: string;
  icons: IconType[];
  is_public: boolean;
  is_new: boolean;
  image?: string;
};

export function getContentImageUrl(content: Content): string {
  return content.image
    ?? `${designBaseUrl}/assets_resized/formatline/design/pc/contents/${content.en_name}/catalog.png`;
}

export type ContentsCategory = {
  id: number;
  name: string;
  contents: Content[];
};

export type SamplePageNameEn = 'index' | 'construction' | 'reform';

export type BasicOption = {
  id: number;
  for: string;
  sample_page_name: SamplePageNameEn;
  price: number;
  is_lowest_price?: boolean;
  contents: Content[];
};

export type Work = {
  name: string;
  url: {
    sp: string;
    pc: string;
  };
};

export type APIDataProps = {
  designs: Design[];
  basic: {
    contents: Content[];
    options: BasicOption[];
  };
  content_categories: ContentsCategory[];
  works: Work[];
};

async function request(url: string): Promise<any> {
  const res = await axios.get(url, { timeout: 5000 });
  return res.data;
}

export async function get(): Promise<APIDataProps> {
  const res = await request(apiUrl);
  return res;
}

export function getAllContentsFromApiData(data?: APIDataProps): Content[] {
  if (!data) {
    return [];
  }
  const basicContents = data.basic.contents;
  const additionalContents = data.content_categories.flatMap(({ contents }) => contents);
  return [...basicContents, ...additionalContents];
}

export function getColorIdFromIndex(index: number): string {
  return `0${index + 1}`.slice(-2);
}
